import React, { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = anonymous
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      const token = localStorage.getItem("otopark_token");
      if (!token) { setUser(null); return; }
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        localStorage.removeItem("otopark_token");
        setUser(null);
      }
    })();
  }, []);

  const login = async (email, password, totp = null, rememberMe = false) => {
    setError(null);
    try {
      const payload = { email, password, remember_me: !!rememberMe };
      if (totp) payload.totp = totp;
      const { data } = await api.post("/auth/login", payload);
      if (data?.requires_2fa) {
        return { requires_2fa: true };
      }
      localStorage.setItem("otopark_token", data.token);
      // "Beni Hatırla" bilgisini sakla — sliding refresh kararı için
      if (rememberMe) localStorage.setItem("otopark_remember", "1");
      else localStorage.removeItem("otopark_remember");
      setUser(data.user);
      return data.user;
    } catch (e) {
      setError(formatApiError(e));
      throw e;
    }
  };

  const register = async (payload) => {
    setError(null);
    try {
      const { data } = await api.post("/auth/register", payload);
      localStorage.setItem("otopark_token", data.token);
      setUser(data.user);
      return data.user;
    } catch (e) {
      setError(formatApiError(e));
      throw e;
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_e) { /* noop */ }
    localStorage.removeItem("otopark_token");
    localStorage.removeItem("otopark_remember");
    setUser(null);
  };

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (_e) { /* noop */ }
  };

  return (
    <AuthContext.Provider value={{ user, error, login, register, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
